const translations = {
  fr: {
    centralMarkets: {
      full: 'Full',
    },
  },

  en: {
    centralMarkets: {
      full: 'Full',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/centralMarkets/i18n/centralMarkets.js